/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const MetricsReview56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M16 36a8 8 0 110 16 8 8 0 010-16zm32-4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M17 24a2.001 2.001 0 00-1.995 1.85L15 26v15a2 2 0 003.995.15L19 41V26a2 2 0 00-2-2z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M29 15a2.001 2.001 0 00-1.995 1.85L27 17v24a2 2 0 003.995.15L31 41V17a2 2 0 00-2-2z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M41 33a2.001 2.001 0 00-1.995 1.85L39 35v6a2 2 0 003.995.15L43 41v-6a2 2 0 00-2-2z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M7 10a1 1 0 01.993.883L8 11v30a7 7 0 006.76 6.996L15 48h34a1 1 0 01.117 1.993L49 50H15a9 9 0 01-8.996-8.735L6 41V11a1 1 0 011-1z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M17 22c2.21 0 4 1.79 4 4v15c0 2.21-1.79 4-4 4s-4-1.79-4-4V26c0-2.21 1.79-4 4-4zm0 2a2.001 2.001 0 00-1.995 1.85L15 26v15a2 2 0 003.995.15L19 41V26a2 2 0 00-2-2zm12-11c2.21 0 4 1.79 4 4v24c0 2.21-1.79 4-4 4s-4-1.79-4-4V17c0-2.21 1.79-4 4-4zm0 2a2.001 2.001 0 00-1.995 1.85L27 17v24a2 2 0 003.995.15L31 41V17a2 2 0 00-2-2zm12 16c2.21 0 4 1.79 4 4v6c0 2.21-1.79 4-4 4s-4-1.79-4-4v-6c0-2.21 1.79-4 4-4zm0 2a2.001 2.001 0 00-1.995 1.85L39 35v6a2 2 0 003.995.15L43 41v-6a2 2 0 00-2-2z"
            />
            <g fillRule="nonzero">
                <path
                    fill={vars.bdlBoxBlue}
                    d="M35.5 7a8.5 8.5 0 016.677 13.761l5.53 5.532a1 1 0 01-1.32 1.497l-.094-.083-5.532-5.53A8.5 8.5 0 1135.5 7zm0 2a6.5 6.5 0 100 13 6.5 6.5 0 000-13z"
                />
                <path fill={vars.white} d="M35.5 9a6.5 6.5 0 110 13 6.5 6.5 0 010-13z" />
                <path
                    fill={vars.bdlBoxBlue}
                    d="M36.526 10.842a.499.499 0 01.632-.316 4.886 4.886 0 013.337 4.412l.005.224v.338a.5.5 0 01-.992.09l-.008-.09v-.338a3.887 3.887 0 00-2.658-3.688.499.499 0 01-.316-.632z"
                />
            </g>
        </g>
    </AccessibleSVG>
);

export default MetricsReview56;
